import { render, staticRenderFns } from "./ProductPadQ.vue?vue&type=template&id=c86b39c0&scoped=true"
import script from "./ProductPadQ.vue?vue&type=script&lang=js"
export * from "./ProductPadQ.vue?vue&type=script&lang=js"
import style0 from "./ProductPadQ.vue?vue&type=style&index=0&id=c86b39c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86b39c0",
  null
  
)

export default component.exports